


















































































































































































































































































































































import {Component, Vue, Watch} from "vue-property-decorator";
import {namespace} from "vuex-class";
import FillSt120Payload, {PurchaseType} from "@/dto/archive/ST120Payloads";
import DocumentService from "@/services/DocumentService";
import RouteNames from "@/router/RouteNames";
import Workspaces from "@/state/Workspaces";
import PortalCheckbox from "@/components/common/PortalCheckbox.vue";
import PortalInput from '@/components/new_style_components/PortalInput.vue';
import PortalAddress from "@/components/profile/branches/PortalAddress.vue";
import PortalDate from "@/components/common/PortalDate.vue";
import {ifValid, processError} from "@/utils/ComponentUtils";
import Application from "@/state/Application";

const AppModule = namespace("App");
const Auth = namespace("Auth");

@Component({
  components: {PortalAddress, PortalInput, PortalCheckbox, PortalDate}
})
export default class ST_120 extends Vue {

  @Auth.Getter("hasAdministrativePrivileges")
  private hasAdministrativePrivileges!: boolean;

  private routes = RouteNames;


  private request = new FillSt120Payload();

  private purchaseTypes: Record<PurchaseType, boolean> = {
    [PurchaseType.MATERIAL]: false,
    [PurchaseType.SERVICE]: false,
    [PurchaseType.FOOD]: false,
    [PurchaseType.STATE_RESALE]: false,
    [PurchaseType.COUNTRY_RESALE]: false
  };

  private appropriateCertificateOption: Record<string, boolean> = {
	  ["SINGLE"]: false,
	  ["BLANKET"]: false,
  }

  private opportunityTypesStr = "";
  private productsStr = "";

  public mounted(): void {
    if (!this.hasAdministrativePrivileges) {
      this.$router.push(this.routes.HOME);
	  return
    }
	Application.startLoading()
	DocumentService.getST120FillingData(this.$route.params.documentId).then(
		res => {
			this.request = new FillSt120Payload(res.data);
		},
		err => processError(err, this)
	).finally(Application.stopLoading)
  }


  private saveForm(): void {
    ifValid(this, () => {
      // Convert purchase types to array
      const selectedPurchases: PurchaseType[] = Object.entries(this.purchaseTypes)
        .filter(([_, value]) => value)
        .map(([key, _]) => key as PurchaseType);
      
      this.request.purchases = selectedPurchases.length > 0 ? selectedPurchases : null;

      Application.startLoading();
      DocumentService.fillST120(this.documentId, this.request).then(
        () => {
          Application.stopLoading();
          // Navigate back to list
          this.$router.push({
            name: this.routes.ARCHIVE_ST120,
            params: {wsType: "c", wsId: `${Workspaces.getCurrent.id}`}
          });
        },
        error => processError(error, this)
      )
    });
  }

  get documentId(): number {
    return Number.parseInt(this.$route.params.documentId);
  }

  @Watch("request.purchaser.address.isResidential")
	private onPurchaserAddressChange(newValue: boolean): void {
		this.request.foreignPurchaser = !newValue;
	}

}
